/**********************************

  wp_fast_ship.js   (Tootsie)

  Cookie helpers + the "No Error" / stale-date self-heal + the single
  auto-trigger that fires a zip lookup on load when a zipcode cookie
  is (or becomes) available.

  ZIP ACQUISITION: handled solely by assets/worldpantry-ipzipcode.js
  (the boss's app-proxy file -- key stays server-side). The old inline
  IPStack call and its exposed access_key have been REMOVED.

  Tootsie has NO live inventory, so there are no product-inventory
  functions here -- just the helpers + auto-trigger. Shipping
  submit/display logic lives in snippets/worldpantry-fast-shipping-logic.liquid.

***********************************/

/* ============================================================
   CONFIG -- per-site values.
   ============================================================ */
var WP_FS = {
  cookies: {
    zip:       'zipcode',
    fsZip:     'FastShip.ZipCode',
    receiveBy: 'FastShip.ReceiveByDateTime',
    orderBy:   'FastShip.OrderByDateTime',
    calcError: 'FastShip.FastShipCalculationError'
  },
  zipInputSelector: '.zip_input',
  formSelector:     'form.js-fs-form'
};

/**********************************
  Cookie functions
***********************************/
// Clean form -- no doubled "; ;".
function setSessionCookie(name, value) {
  document.cookie = name + "=" + value + "; path=/";
}

function getSessionCookie(name) {
  const nameKey = name + "=";
  const cDecoded = decodeURIComponent(document.cookie);
  const cArr = cDecoded.split("; ");
  let res;
  cArr.forEach((val) => {
    if (val.indexOf(nameKey) === 0) res = val.substring(nameKey.length);
  });
  return res;
}

// Added: the canonical shared logic calls deleteCookie. (The old
// wp_fast_ship.js never defined it -- without this the shared logic
// would throw.)
function deleteCookie(name) {
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  var result = null;
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1);
    if (c.indexOf(nameEQ) === 0) result = decodeURIComponent(c.substring(nameEQ.length));
  }
  return result;
}

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value != null ? value : "") + expires + "; path=/";
}

function isValidZip(str) {
  return /^\d{5}(-\d{4})?$/.test(str || "");
}

/**********************************
  Self-heal: clear a stuck error cookie ("No Error" success value, or
  no valid zip beside it), and clear legacy non-ISO date cookies so they
  re-fetch as ISO (the old "June 11" format reverts in Firefox).
***********************************/
(function selfHealFastShipCookies() {
  var err = getSessionCookie(WP_FS.cookies.calcError);
  if (err) {
    var zip = getSessionCookie(WP_FS.cookies.fsZip);
    if (err === "No Error" || !isValidZip(zip)) {
      deleteCookie(WP_FS.cookies.calcError);
    }
  }
  var receiveBy = getSessionCookie(WP_FS.cookies.receiveBy);
  var orderBy = getSessionCookie(WP_FS.cookies.orderBy);
  if ((receiveBy && isNaN(new Date(receiveBy))) ||
      (orderBy && isNaN(new Date(orderBy)))) {
    deleteCookie(WP_FS.cookies.receiveBy);
    deleteCookie(WP_FS.cookies.orderBy);
  }
})();

/**********************************
  Auto-trigger (with first-visit poll).

  The boss's worldpantry-ipzipcode.js sets the `zipcode` cookie via an
  ASYNC fetch to the app proxy. On a first visit that fetch can resolve
  AFTER $(document).ready has already run -- so a single check at ready
  finds no cookie and gives up, and the date never appears until the
  next visit (when the cookie is already present).

  Fix: check immediately, then poll briefly (every 200ms, up to ~4s).
  The moment the proxy's fetch lands the `zipcode` cookie, the next poll
  catches it, prefills the inputs, and submits the shared form once.
  Stops as soon as it succeeds, finds a stored result, or times out --
  it can never loop forever.

  only the consumer side polls.
***********************************/
$(document).ready(function () {
  var attempts = 0;
  var maxAttempts = 20;          // 20 * 200ms = ~4 seconds

  function tryAutoLookup() {
    // Already have a stored result? Nothing to do.
    if (getSessionCookie(WP_FS.cookies.fsZip) && getSessionCookie(WP_FS.cookies.receiveBy)) {
      console.log("FastShip data already exists, skipping auto lookup");
      return;
    }

    var zip = getCookie(WP_FS.cookies.zip);
    if (isValidZip(zip)) {
      console.log("fast geo zip " + zip);
      $(WP_FS.zipInputSelector).val(zip);
      $(WP_FS.formSelector).first().submit();
      return;                    // success -- stop polling
    }

    attempts++;
    if (attempts < maxAttempts) {
      setTimeout(tryAutoLookup, 200);
    } else {
      console.log("no valid zipcode after waiting - giving up auto lookup");
    }
  }

  tryAutoLookup();
});
